import { ThemeService } from '@program-suite/theming';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { baseUrlInterceptor } from '../config/base-url.interceptor';
import { authHeaderInterceptor } from '../config/auth-header.interceptor';
import { tokenExpiredInterceptor } from '../config/token-expired.interceptor';
import { spinnerInterceptor } from '../config/spinner.interceptor';
import { AuthStore } from '@program-suite/data-auth';

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore(),
    provideEffects(),
    provideExperimentalZonelessChangeDetection(),
    provideRouter(appRoutes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([baseUrlInterceptor, authHeaderInterceptor, tokenExpiredInterceptor, spinnerInterceptor])
    ),
    provideAppInitializer(async () => {
      const themeService = inject(ThemeService);
      
      themeService.initTheme({
        colorPrimary: "#009444"// apply theme color
      });
    }),
    provideAppInitializer(async () => {
      const authStore = inject(AuthStore);
      return await authStore.loadFromStorage(); // check if user is logged in 
    }),
  ],
};
